var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Banner,{directives:[{name:"stat",rawName:"v-stat.brow",value:({
    tag: 'banner.index_brow|banner模块曝光',
    ext: _setup.getBiExt(),
  }),expression:"{\n    tag: 'banner.index_brow|banner模块曝光',\n    ext: getBiExt(),\n  }",modifiers:{"brow":true}}],staticClass:"banner-comp",attrs:{"type":"swiper","bannerDpPageId":_setup.DP_PAGE,"bannerDpPositionId":_setup.BANNER_DP_POSITION,"transformer":_setup.transformer},on:{"click":_setup.bannerClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }